import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { StatusBadge } from "@h2j-data-team/ui";
import type { AppAnalysisStatus } from "@repo/shared";

type NonCompleted = Exclude<AppAnalysisStatus, "completed">;

const TONE: Record<NonCompleted, "info" | "danger" | "neutral"> = {
  processing: "info",
  failed: "danger",
  cancelled: "neutral",
};

// Lifecycle badge shown for a non-completed analysis (processing/failed/
// cancelled). Renders nothing for a completed analysis so the results view is
// unchanged.
export function AnalysisStatusBadge({ status }: { status: AppAnalysisStatus }) {
  const { t } = useTranslation("analyses");
  if (status === "completed") return null;
  return (
    <StatusBadge tone={TONE[status]} dot={status !== "processing"}>
      {status === "processing" && (
        <Loader2 size={12} className="shrink-0 animate-spin" aria-hidden />
      )}
      {t(`status.${status}`)}
    </StatusBadge>
  );
}
